import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoFil: CultureInfo = {
  name: 'fil',
  displayName: 'Filipino',
  iso3LanguageCode: 'fil',
  iso2LanguageCode: 'fil',
  ietfLanguageTag: 'fil',
  parent: null
};
